<template>
  <div class="investor">
    <van-dropdown-menu>
      <van-dropdown-item
        get-container="body"
        v-model="investor_request.areaCode"
        :options="region"
        :title-class="'left-class'"
        @change="onRefresh(true)"

      />
      <van-dropdown-item
        get-container="body"
        v-model="investor_request.rankingCode"
        :options="ranking"
        :title-class="'right-class'"
        @change="onRefresh(true)"

      />
    </van-dropdown-menu>
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
        >
          <listInvestor
            v-for="(item, index) in records"
            :key="index"
            :record="item"
          ></listInvestor>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { DropdownMenu, DropdownItem } from "vant";
import listInvestor from "../components/listInvestor";

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "InvestmentInvestor",
  components: {
    listInvestor,
  },
  data() {
    return {
      region: [
        { text: "区域", value: "" },
        { text: "省内", value: 1 },
        { text: "省外", value: 2 },
        { text: "境外", value: 3 },
      ],
      ranking: [
        { text: "企业排行", value: "" },
        { text: "全球500强", value: 0 },
        { text: "全国500强", value: 1 },
        { text: "行业龙头", value: 2 },
        { text: "大型民企", value: 3 },
        { text: "国际知名品牌", value: 4 },
        { text: "国内知名品牌", value: 5 },
        { text: "其他", value: 6 },
      ],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      error_true: false,
      records: [],
      investor_request: {
        current: "", //当前页
        pageSize: 10, //每页条数
        areaCode: "", //区域编码
        rankingCode: "", // 企业排行编码
      },
    };
  },
  computed: {
    ...mapGetters('investment', ['getInvestorOption'])
  },
  created() {
    this.setInvestmentTitle("投资方列表");
    this.investor_request.areaCode = this.getInvestorOption.areaCode
    this.investor_request.rankingCode = this.getInvestorOption.rankingCode
  },
  watch: {},
  methods: {
    ...mapActions("investment", ["setInvestmentTitle", "getInvestorList", "setInvestorOption"]),
    onLoad() {
      console.log("加载下一页");
      if(!this.error_true){
          this.investor_request.current++
      }
      this.refresh();
    },
    //下拉刷新时触发
    onRefresh(value) {
      if(value){
        this.setInvestorOption({
          areaCode: this.investor_request.areaCode,
          rankingCode: this.investor_request.rankingCode,
        })
      }
      this.investor_request.current = 1;
      this.records = [];
      this.refresh();
    },
    refresh() {
      this.getInvestorList(this.investor_request)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          this.error_true = false
          if(res){
            if (res.pages > this.investor_request.current) {
              this.finished = false;
            } else {
              this.finished = true;
            }
            this.records = this.records.concat(res.records);
          }else{
            this.finished = true;
          }

        })
        .catch((res) => {
          console.log(res)
          this.refreshing = false;
          this.loading = false;
          this.finished = false;
          this.error = true;
          this.error_true = true
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.investor {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  background: #F5F6F9;
  .list {
    padding: 0 12px;
  }
  /deep/.van-dropdown-menu__bar {
    justify-content: flex-start;
  }
  /deep/.van-dropdown-menu__item {
    flex: none;
    margin-right: 20px;
  }
  /deep/.left-class {
    display: inline-flex;
    color: #333333;
    font-size: 14px;
    padding: 0 12px;
  }
  /deep/.left-class::before {
    content: "";
    display: inline-flex;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
  }
  /deep/.right-class {
    display: inline-flex;
    color: #333333;
    font-size: 14px;
  }
  /deep/.right-class::before {
    content: "";
    display: inline-flex;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
  }
}
</style>